import { useQuery } from '@tanstack/react-query';

import { UTBReportData } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const retrieveUTBReportData = async (batchId: string, page: number): Promise<UTBReportData> => {
  try {
    const result = await apiClient.batchesReports.retrieveUtbReportData.mutation({ params: { id: batchId }, body: { page } });
    if (result.status !== 200) throw result.body;

    return result.body.data as UTBReportData;
  } catch (error) {
    showErrorToast(error, 'Error fetching UTB report data!');
  }
};

export const useRetrieveUTBReportData = (batchId: string, page = 0) =>
  useQuery({
    queryKey: ['retrieve-utb-report-data', batchId, page],
    queryFn: async () => retrieveUTBReportData(batchId, page),
    enabled: !!batchId,
  });
